const reducer = (state = { devid: '', omgid: '' }, action) => {
  switch (action.type) {
    case 'map_app_info': {
      return {
        ...state,
        devid: (action.data && action.data.devid) || '',
        omgid: (action.data && action.data.omgid) || '',
        imsi: (action.data && action.data.imsi) || '',
        guid: (action.data && action.data.guid) || '',
        qua: (action.data && action.data.guid) || '',
      };
    }
    case 'map_app_main_account': {
      return {
        ...state,
        ...action.data,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default reducer;
